// Tâche 1455 (Eric 2026-06) — Bandeau « la liste des termes a bougé depuis ce
// balayage ».
//
// > « Si jamais la liste des termes a été mise-à-jour après le balayage
// >   affiché, tu vas laisser la liste des termes non acceptés ou refusés
// >   encore visible, et ajouter un bandeau précisant que X termes ont été
// >   ajoutés (et indiquer la version correcte de chacun entre parenthèse,
// >   séparés par une virgule). »
//
// ⚠️ Le bandeau ne relance rien et ne remplace pas le balayage affiché : ce
// dernier porte du travail de tri non terminé, et l'écraser ferait perdre ce
// travail. C'est un AVERTISSEMENT, pas une action forcée.
import { Warning } from "@phosphor-icons/react";
import { useLang } from "../../contexts/LanguageContext";

export const BandeauTermesAjoutes = ({ termes }) => {
  const { tr } = useLang();
  if (!termes?.length) return null;

  const graphies = termes.map((t) => t.terme).filter(Boolean).join(", ");

  return (
    <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3 flex items-start gap-2"
         data-testid="orthographe-bandeau-termes-ajoutes">
      <Warning size={16} className="text-amber-600 flex-shrink-0 mt-0.5" />
      <p className="text-xs text-amber-900">
        <strong>
          {termes.length} {tr(
            termes.length === 1 ? "terme a été ajouté" : "termes ont été ajoutés",
            termes.length === 1 ? "term was added" : "terms were added")}
        </strong>
        {" "}
        {tr("depuis ce balayage", "since this scan")} ({graphies}).
        {" "}
        {tr("Ce balayage ne les contient donc pas. Terminez le tri ci-dessous, puis relancez un balayage pour les chercher à leur tour.",
            "So this scan does not include them. Finish sorting below, then run a new scan to look for them too.")}
      </p>
    </div>
  );
};

export default BandeauTermesAjoutes;
